import useEventMode from '@/hooks/useEventMode';
import { useLanguage } from '@/context/LanguageContext';
import { Sparkle } from '@phosphor-icons/react';

/**
 * Slim, sticky-top banner shown across authenticated pages whenever
 * EVENT_MODE is on. Conveys "all features unlocked during the event" so
 * users don't look for upgrade buttons.
 */
export default function EventModeBanner() {
  const { enabled, label } = useEventMode();
  const { language } = useLanguage();
  if (!enabled) return null;
  const text = (label && (label[language] || label.tr)) || '';
  return (
    <div
      className="bg-gradient-to-r from-[#0F1B36] via-[#1E3A8A] to-[#0F1B36] text-white"
      data-testid="event-mode-banner"
    >
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium">
        <Sparkle size={14} weight="fill" className="text-[#3CD9B8] shrink-0" />
        <span className="truncate">{text}</span>
      </div>
    </div>
  );
}
